export const properties = {
    fullPageLicenseKey: process.env.NODE_ENV === 'production' ? 'FFB7DD19-97A94AAE-B81BF920-7C599853' : 'OPEN-SOURCE-GPLV3-LICENSE'
};